import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=77c2e0b6"
import script from "./Pricing.vue?vue&type=script&lang=ts"
export * from "./Pricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports